import useAuthStore from '../../../stores/authStore';
import { USER_ROLE } from '../../../types/auth';

const SuperAdminHeaderActions = () => {
	const { user } = useAuthStore();

	const getUserRoleDisplay = () => {
		if (!user) return '';
		switch (user.role) {
			case USER_ROLE.SUPER_ADMIN:
				return 'Super Admin';
			case USER_ROLE.SALON_OWNER:
				return 'Salon Owner';
			case USER_ROLE.STAFF:
				return 'Staff';
			default:
				return '';
		}
	};

	return (
		<div className="flex items-center gap-3 md:gap-5 flex-shrink-0">
			<div className="text-right hidden md:block">
				<div className="font-bold text-base">{user?.name}</div>
				<div className="text-xs opacity-80">{getUserRoleDisplay()}</div>
			</div>
		</div>
	);
};

export default SuperAdminHeaderActions;
